import React from 'react';
import styled from 'styled-components';

const BoardViewToggle = styled.div`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem;
    border-radius: var(--smallRadius);
    background: ${p => p.theme.low};
`;

const BoardViewButton = styled.button`
    border: none;
    border-radius: var(--smallRadius);
    padding: 0.7rem 1rem;
    cursor: pointer;
    background: ${p => p.active ? p.theme.background : 'transparent'};
    color: ${p => p.active ? 'var(--main)' : p.theme.color};
    box-shadow: ${p => p.active ? p.theme.out : 'none'};

    h6 {
        margin: 0;
        font-family: "fontBold";
    }
`;

export const Board_View_Toggle = (props) => {
    return (
        <BoardViewToggle>
            <BoardViewButton
                type="button"
                active={props.viewMode === 'table'}
                aria-pressed={props.viewMode === 'table'}
                onClick={() => props.onViewModeChange('table')}
            >
                <h6>{props.t('Table')}</h6>
            </BoardViewButton>
            <BoardViewButton
                type="button"
                active={props.viewMode === 'columns'}
                aria-pressed={props.viewMode === 'columns'}
                onClick={() => props.onViewModeChange('columns')}
            >
                <h6>{props.t('Columns')}</h6>
            </BoardViewButton>
        </BoardViewToggle>
    );
};
